// packages/content/src/strings/villagers.ts — species and personality names, villager UI words (M2-T02)
import type { StringBank } from '../schema/strings';
export default {
  speciesCat: 'cat', speciesDog: 'dog', speciesRabbit: 'rabbit', speciesBear: 'bear', speciesDuck: 'duck', speciesFrog: 'frog',
  speciesSheep: 'sheep', speciesSquirrel: 'squirrel',
  personalityEasygoing: 'Easygoing', personalitySporty: 'Sporty', personalityGrumpy: 'Grumpy', personalityFancy: 'Fancy',
  personalityBubbly: 'Bubbly', personalitySweet: 'Sweet',
  tier0: 'Just met', tier1: 'Acquaintance', tier2: 'Friend', tier3: 'Good friend', tier4: 'Close friend', tier5: 'Best friend',
  talkMore: 'Tap to continue', talkGift: 'Give a gift', talkBye: 'Bye!', talkProtect: 'Ask {name} to stay', talkUnprotect: 'Let {name} move if needed',
  protectedNote: 'The mayor asked {name} to stay.',
  giftTitle: 'A gift for {name}', giftNone: 'Nothing in your pockets to give.', giftGive: 'Give', giftPick: 'Pick something to give.',
  houseTitle: "{name}'s house", visitAway: '{name} is out right now.', visitAsleep: '{name} is asleep. Shh.',
  arrivedToast: '{name} moved into town!', leftToast: '{name} moved away.',
} as const satisfies StringBank;
